import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Actions,
  Column,
  ErrorText,
  Field,
  Fields,
  FormBody,
  Intro,
  OutlineButton,
  PrimaryButton,
  TextInput,
  Title,
} from 'components/layout/Auth/AuthForm/styles';

type InformarEmailProps = {
  login: string;
  loading: boolean;
  erro: string | null;
  onChangeLogin: (login: string) => void;
  onSubmit: (login: string) => void;
};

const emailValido = (valor: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor.trim());

const InformarEmail: React.FC<InformarEmailProps> = ({
  login,
  loading,
  erro,
  onChangeLogin,
  onSubmit,
}) => {
  const history = useHistory();
  const [tocado, setTocado] = useState(false);

  const invalido = tocado && !!login && !emailValido(login);

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    setTocado(true);
    if (emailValido(login)) onSubmit(login.trim());
  };

  return (
    <Column gap={24}>
      <Intro>
        <Title>
          Preencha o campo abaixo
          <br />
          para recuperar seu acesso:
        </Title>
      </Intro>

      <form onSubmit={handleSubmit} noValidate>
        <FormBody>
          <Fields>
            <Field>
              <TextInput
                id="login"
                name="login"
                type="email"
                label="E-mail"
                placeholder="Digite"
                required
                fullWidth
                autoFocus
                error={invalido || !!erro}
                value={login}
                onChange={(e) => onChangeLogin(e.target.value)}
                onBlur={() => setTocado(true)}
              />
              {invalido && <ErrorText>Insira um e-mail válido</ErrorText>}
              {!invalido && erro && <ErrorText>{erro}</ErrorText>}
            </Field>
          </Fields>

          <Actions>
            <OutlineButton
              type="button"
              variant="secondary"
              shape="pill"
              fullWidth
              onClick={() => history.push('/')}
            >
              Voltar
            </OutlineButton>
            <PrimaryButton
              type="submit"
              shape="pill"
              fullWidth
              disabled={loading || !login}
            >
              {loading ? 'Buscando...' : 'Continuar'}
            </PrimaryButton>
          </Actions>
        </FormBody>
      </form>
    </Column>
  );
};

export default InformarEmail;
